import React, { useEffect } from 'react';
import { CardComponent } from '../../CardComponent';
import { useAppSelector } from '../../hooks';
import { selectAttributesTableState } from './attributesTableComponentSlice';

export function AttributesTableComponent() {
  const componentState = useAppSelector(selectAttributesTableState);
  const isLoading = componentState.isLoading;
  const hasError = componentState.hasError;
  const html = componentState.apiResponse.values;
  const periodComparisonID = componentState.apiResponse.p2.PERIOD_ID;
  useEffect(() => {
    if (html.length) {
      // these functions are defined in website/js/pages/drilldown.js
      // @ts-ignore
      addClickEvents();
      // @ts-ignore
      updatePeriodValues([], periodComparisonID || window.newPeriod);
    }
  }, [html]);

  return (
    <div>
      <CardComponent
        title={'Survey Responses'}
        isLoading={isLoading}
        hasError={hasError}
        disableCardBackgroundColor
      >
        <main
          id="attrTable"
          className="center"
          style={{
            paddingRight: '2px',
            paddingLeft: '2px',
            overflow: 'auto',
            maxHeight: '95%',
            minHeight: '635px'
          }}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </CardComponent>
    </div>
  );
}
